import { Objective } from "../types";

class stepLoader {
  private static instance: stepLoader;
  private constructor() {
    //Intentionally blank
  }

  public static getInstance() {
    if (!this.instance) this.instance = new stepLoader();
    return this.instance;
  }

  loadDatafromJson(data: any) {
    const objectives: Objective[] = data.default.chapters[0].objectives;
    return objectives;
  }

  // loadData(): objective[] {
  //     // const objectives: objective[] = StepsData.chapters[0].objectives;
  //     const objectives: objective[];
  //     return objectives;
  // }
}

export default stepLoader;
